import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/research/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Here are the different ways folks contribute to Open UI, and the different skills/pieces of work.`}</p>
    <h3>{`Contributor`}</h3>
    <p>{`A contributor is any person who has participated in some way, either by joining a meeting and participating, or writing on an issue or PR. If you’re reading this, you’re likely already a contributor. Thank you :D!`}</p>
    <h3>{`Champion`}</h3>
    <p>{`A champion has slightly more responsbility than a contributor. A chanmpion is responsible for moving a proposal from one stage to the next, attending meetings, gathering input, synthesizing it, and advancing it through the `}<a parentName="p" {...{
        "href": "/working-mode"
      }}>{`stages`}</a>{`. In order to become and editor you need to:`}</p>
    <ul>
      <li parentName="ul">{`Be a member of the community group`}</li>
      <li parentName="ul">{`Be able to alot time to attend weekly meetings while youre feature is being worked on`}</li>
      <li parentName="ul">{`Be available to review and advance tasks outside of the weekly meeting`}</li>
    </ul>
    <h3>{`Editor`}</h3>
    <p>{`An editor owns a specification, and is responsible for ensuring it develops and remains stable. This means reviewing PRs to the specifications you are an editor of, considering input and updating prose in a consistent and accessible voice. In order to become and editor you need to:`}</p>
    <ul>
      <li parentName="ul">{`Be a member of the community group`}</li>
      <li parentName="ul">{`Have five substantial technical contributions to a specification that you wish to edit`}</li>
      <li parentName="ul">{`Be nominated for editorship by either the chairs or someone that is currently an editor of that specification`}</li>
      <li parentName="ul">{`Resolved on by the community during telecon or two other editors or chairs`}</li>
    </ul>
    <h3>{`Chair`}</h3>
    <p>{`The chairs' primary responsibilities are to facilitate weekly meetings, ensure progress towards goals is made, mentor and onboard contributors, champions, and editors, create and foster a respectful and productive atmosphere for the community, enforce the working mode.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      